module.exports = __webpack_public_path__ + "media/images/site/serie-c-76bd2aac1bad1d95644c2efc73b4bcc9.png";